import {withNamespaces} from "react-i18next";
import React from "react";
import SearchBox from "./SearchBox";
import i18n from '../../../i18n';

const AddressField = ({ address, inputName }) => {
  const t = i18n.t;

  return (
    <div>
      <SearchBox
        searchHint='123, Maple Dr.'
        t={t}
        address={address}
        selectColor="#DE1245"
        country="US"
        inputName={inputName}
        onlyAddress
      />
    </div>
  );
};

export default withNamespaces()(AddressField);